import { Sparkles } from "lucide-react"
import { TooltipWrapper, TooltipContent, TooltipTrigger } from "./tooltip"

export function AIGeneratedIndicator() {
  return (
    <TooltipWrapper>
      <TooltipTrigger asChild>
        <div
          className="fixed bottom-4 left-4 z-50 flex items-center gap-2 bg-gradient-to-r from-[#FF5533] to-[#FF7A5C] text-white px-3 py-2 rounded-full shadow-lg cursor-pointer hover:shadow-xl transition-all duration-300 border border-white"
          tabIndex={0}
          role="button"
          aria-label="AI-Generated"
        >
          <Sparkles className="h-4 w-4" />
          <span className="text-sm font-medium">AI-Generated</span>
        </div>
      </TooltipTrigger>
      <TooltipContent side="top" className="ml-[70px]">
        <p className="">This application data is generated by AI</p>
      </TooltipContent>
    </TooltipWrapper>
  )
}
